var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSmallRightBlue50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "16x16/ArrowSmall_Right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.53325386,7.6948727 L5.94320013,11.0631969 L13.5467461,3.5524604 C13.8193301,3.2825132 14.2624538,3.2825132 14.5350378,3.5524604 C14.8083207,3.8217172 14.8083207,4.2594321 14.5350378,4.5286889 L6.43734596,12.5275396 C6.16476198,12.7974868 5.72163827,12.7974868 5.44905429,12.5275396 L1.54496219,8.6711012 C1.27167927,8.4018444 1.27167927,7.9641295 1.54496219,7.6948727 C1.81754617,7.4249255 2.26066988,7.4249255 2.53325386,7.6948727 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02-Collab",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.4-\\u2014-Collab-\\xB7-Move-02",
    transform: "translate(-707.000000, -537.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropdown",
    transform: "translate(690.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(16.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16x16/Check",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#0067DF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallRightBlue50);
export default __webpack_public_path__ + "static/media/ArrowSmall_Right_Blue_50.fd8c3360471d86d373e31b41da89e6b8.svg";
export { ForwardRef as ReactComponent };